import { create } from 'zustand';

interface CompletedAnalysis {
  id: string;
  name: string;
}

interface AnalysisNotificationState {
  initiatedCount: number;
  completedAnalyses: CompletedAnalysis[];
  setInitiated: () => void;
  decrementInitiated: () => void;
  dismissInitiated: () => void;
  addCompleted: (id: string, name: string) => void;
  dismissCompleted: (id: string) => void;
}

export const useAnalysisNotificationStore = create<AnalysisNotificationState>((set) => ({
  initiatedCount: 0,
  completedAnalyses: [],
  setInitiated: () => set((state) => ({ initiatedCount: state.initiatedCount + 1 })),
  decrementInitiated: () =>
    set((state) => ({ initiatedCount: Math.max(0, state.initiatedCount - 1) })),
  dismissInitiated: () => set({ initiatedCount: 0 }),
  addCompleted: (id, name) =>
    set((state) => ({
      completedAnalyses: state.completedAnalyses.some((a) => a.id === id)
        ? state.completedAnalyses
        : [...state.completedAnalyses, { id, name }],
    })),
  dismissCompleted: (id) =>
    set((state) => ({
      completedAnalyses: state.completedAnalyses.filter((a) => a.id !== id),
    })),
}));
